import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { SearchEntityStateActions, } from '../../reducers/SearchEntityReducer/SearchEntityReducer.js';
import { ConnectionPagingButtons } from '../ConnectionPagingButtons/ConnectionPagingButtons.js';
export function SearchEntityPagingButtons({ searchEntityState, dispatchSearchEntityState }) {
    const handlePagingChange = useCallback((paging, pagingAction) => {
        dispatchSearchEntityState(new SearchEntityStateActions.SetPaging(paging, pagingAction));
    }, [dispatchSearchEntityState]);
    return (_jsx(ConnectionPagingButtons, { connection: searchEntityState.connection, pagingCount: searchEntityState.requestedCount, onPagingChange: handlePagingChange }));
}
//# sourceMappingURL=SearchEntityPagingButtons.js.map